export const GET_COUNTRIES_LOADING = 'GET_COUNTRIES_LOADING';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_ERROR = 'GET_COUNTRIES_ERROR';

export const GET_STATES_LOADING = 'GET_STATES_LOADING';
export const GET_STATES_SUCCESS = 'GET_STATES_SUCCESS';
export const GET_STATES_ERROR = 'GET_STATES_ERROR';

export const GET_CITIES_LOADING = 'GET_CITIES_LOADING';
export const GET_CITIES_SUCCESS = 'GET_CITIES_SUCCESS';
export const GET_CITIES_ERROR = 'GET_CITIES_ERROR';
